import MPAAddAdminMemoModal from './MPAAddAdminMemoModal';

export default MPAAddAdminMemoModal;
